import React, {Component} from "react"
import { Entity } from "aframe-react"

import frameButton from "../components-aframe/frameButton"

import controlBox from "../components-aframe/controlBox"

import ActionButton from "./ActionButton"

import NextArrow from "../assets/icons/ic_right@4x.png"
import PrevArrow from "../assets/icons/ic_left@4x.png"


class ImageGridEven extends Component {

    constructor(props) {
        super(props)

        this.const = {
            distance: -6,

            upDur: "350",
            downDur: "200",

            minOpacity: "0.7",
            maxOpacity: "1.0",

            maxScale: "1.2 1.2 1.2",
            minScale: "1 1 1",
            
            size: this.props.grid.row * this.props.grid.col,
        }

        this.state = {
            page: 0,
        }

        this.material = {
            shader: "flat",
            transparent: true,

            // opacity: 0.7 
        }

        this.geometry = {
            primitive: "plane",

            width: this.props.icon.width, //this.const.smallWidth,
            height: this.props.icon.height, //this.const.smallWidth,
        }

        this.page = 0
        this.pageStart = this.page * this.const.size
        this.maxPage = Math.floor(this.props.items.length / this.const.size) + 1

        this.padded = {
            w: this.geometry.width + this.props.grid.padding.x,
            h: this.geometry.height + this.props.grid.padding.y,
        }

        this.offset = {
            x: (this.props.grid.row - 1) * this.padded.w / 2,
            y: (this.props.grid.col - 1) * this.padded.h / 2,
        }

    }
    
    animationBase(attr, min, max, reverse=false) {
        return (
            <a-animation 
                attribute={attr}
                
                begin={(!reverse) ? "mouseenter" : "mouseleave"}
                end={(!reverse) ? "mouseleave" : "mouseenter"}
                
                dur={ (!reverse) ? this.const.upDur : this.const.downDur } 

                from={ (!reverse) ? min : max }
                to={ (!reverse) ? max : min}
            />
        )
    }

    opacityAnimation(reverse=false) {
        return this.animationBase(
            "material.opacity", 
            this.const.minOpacity, this.const.maxOpacity,
            reverse
        )
    }

    scaleAnimation(reverse=false) {
        return this.animationBase(
            "scale",
            this.const.minScale, this.const.maxScale,
            reverse
        )
    }

    switchPage(dir=1) {
        const next = this.state.page + dir

        if (next >= 0 && next < this.maxPage) {

            this.pageStart = next * this.const.size
            this.setState({
                page: next,
            })

        }
    }

    smallImage(pos, item, geometry=this.geometry, material=this.material) {
        return (
            <Entity
                geometry={geometry}

                material={{
                    ...this.material,
                    src: item.src
                }}

                position={pos}

                events={{
                    clickUp: () => this.props.click(item) 
                }}

                frame-button={{ button: true }}
            >
                {/*this.opacityAnimation()*/}
                {/*this.opacityAnimation(true)*/}

                {this.scaleAnimation()}
                {this.scaleAnimation(true)}
            </Entity>
        )
    }

    generateCols () {

    }

    render() {
        return (
            <Entity position={{x: 0, y: 0, z: 0}} control-box={{ enableX: false, offsetY: 30, offset: 20, doubleX: false, }}>
                <Entity position={{x: 0, y: 0, z: this.const.distance}}>

                    <ActionButton 
                        width={this.props.navigation.buttons.size}
                        height={this.props.navigation.buttons.size}

                        position={{
                            x: (this.props.navigation.buttons.size / 2 + this.props.navigation.buttons.padding.x ) * -1,
                            y: this.padded.h * (this.props.grid.col / 2) + this.props.navigation.buttons.size / 2 + this.props.navigation.buttons.padding.y,
                            z: 0,
                        }}

                        src={PrevArrow}

                        events={{
                            click: () => this.switchPage(-1)
                        }}
                    />

                    <ActionButton 
                        width={this.props.navigation.buttons.size}
                        height={this.props.navigation.buttons.size}

                        position={{
                            x: this.props.navigation.buttons.size / 2 + this.props.navigation.buttons.padding.x, 
                            y: this.padded.h * (this.props.grid.col / 2) + this.props.navigation.buttons.size / 2 + this.props.navigation.buttons.padding.y,
                            z: 0,
                        }}

                        src={NextArrow}

                        events={{
                            click: () => this.switchPage(1)
                        }}
                    />

                    {this.props.items.slice(this.pageStart, this.pageStart+this.const.size).map( (icon, i) => {

                        const pos = { 
                            x: i % this.props.grid.row * this.padded.w - this.offset.x, 
                            y: ( Math.floor(i / this.props.grid.row) * this.padded.h - this.offset.y) * -1, 
                            z: 0
                        }

                        return this.smallImage( 
                            pos, icon
                        )
                    })}


                </Entity>
            </Entity>
        )
    }

}

ImageGridEven.defaultProps = {

    items: [],
    rotation: {x: 0, y: 0, z: 0},

    // Settings for display grid
    grid: {
        row: 4, // Items per row
        col: 3, // Items per column

        padding: {
            x: 0.2, // X Padding of an image 
            y: 0.2, // Y Padding of an image
        },
    },

    // Settings for single icon
    icon: {
        width: 0.96, // Width of an icon
        height: 0.6, // Height of an icon

        maxScale: "1.5 1.5 1.5", // Scale of hovered element
    },

    // Settings for navigation component
    navigation: {

        buttons: {
            size: 0.3, // Size of navigation button

            // Nav buttons padding
            padding: {
                x: 0.1,
                y: 0,
            }
        }
    },

}

export default ImageGridEven


// WEBPACK FOOTER //
// ./src/components/ImageGridEven.js